const widenMaxProduct = (props) => {
  const { baseMaxProduct, maxProduct, productList, updateMaxProduct } = props
  const realProductLimit = productList.length
  const nextProductLimit = maxProduct + baseMaxProduct
  const isExceedRealQuantity = nextProductLimit > realProductLimit

  // if new limit exceed the total product quantity, set it to the total number
  const productLimit = isExceedRealQuantity
    ? realProductLimit
    : nextProductLimit

  updateMaxProduct(productLimit)
}

export default widenMaxProduct
